const DisData = {
    "0": "Apple scab",
    "1": "Black rot",
    "2": "Cedar apple rust",
    "3": "Apple healthy",
    "4": "Blueberry healthy",
    "5": "Powdery mildew",
    "6": "Cherry (including sour) healthy",
    "7": "Cercospora leaf spot Gray leaf spot",
    "8": "Common rust ",
    "9": "Northern Leaf Blight",
    "10": "Corn (maize) healthy",
    "11": "Black rot",
    "12": "Esca (Black Measles)",
    "13": "Leaf blight (Isariopsis Leaf Spot)",
    "14": "Grape healthy",
    "15": "Haunglongbing (Citrus greening)",
    "16": "Bacterial spot",
    "17": "Peach healthy",
    "18": "Pepper, bell Bacterial spot",
    "19": "Pepper, bell healthy",
    "20": "Potato Early blight",
    "21": "Potato Late blight",
    "22": "Potato healthy",
    "23": "Raspberry healthy",
    "24": "Soybean healthy",
    "25": "Squash Powdery mildew",
    "26": "Strawberry Leaf scorch",
    "27": "Strawberry healthy",
    "28": "Tomato Bacterial spot",
    "29": "Tomato Early blight",
    "30": "Tomato Late blight",
    "31": "Tomato Leaf Mold",
    "32": "Tomato Septoria leaf spot",
    "33": "Tomato Spider mites Two-spotted spider mite",
    "34": "Tomato Target Spot",
    "35": "Tomato Tomato Yellow Leaf Curl Virus",
    "36": "Tomato Tomato mosaic virus",
    "37": "Tomato healthy",
    "38": ""
}

export default DisData;